import { gql } from '@apollo/client';

export const FETCH_REPORT_NAME = gql`
  query fetchReportName($reportId: ObjectID!, $organizationId: ObjectID!) {
    fetchReport(
      input: { reportId: $reportId, organizationId: $organizationId }
    ) {
      report {
        name
      }
    }
  }
`;
